import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosResponse } from 'axios';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { DepartmentService } from '@avanta/shared/services/departments';
import { type Department } from '@avanta/shared/types/departments';
import { mapToLabelValue } from '@avanta/shared/utils/common';

export const useFetchDepartments = ({
  centerId,
  isProfileSetup,
}: {
  centerId: string | null;
  isProfileSetup: boolean;
}): UseQueryResult<{ label: string; value: string }[], Error> =>
  useQuery<AxiosResponse<Department[]>, Error, { label: string; value: string }[]>({
    queryKey: [QUERY_KEYS.FETCH_DEPARTMENTS, centerId],
    queryFn: () => DepartmentService.getDepartments(centerId ?? ''),
    enabled: Boolean(centerId) && !isProfileSetup,
    select: response =>
      mapToLabelValue(response.data as unknown as Record<string, string>[], 'id', 'departmentName'),
  });
